import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { PopupListItem } from 'webapp-types';

import ActionNew from 'webapp/components/action-new';
import OptionsButton from 'webapp/components/options-button';
import SubmitButton from 'webapp/components/submit-button';

export interface Args {
	text: string;
	callTrigger: () => void;
	options?: PopupListItem<string>[];
	onOptionClick?: (action: string) => void;
	icon?: IconName;
}

export default class CommonAddButtonComponent extends Component<Args> {
	get isOptionsButtonShown() {
		return !!this.args.options && !!this.args.onOptionClick;
	}

	get options() {
		return this.args.options || [];
	}

	get icon() {
		return this.args.icon || 'Plus';
	}

	@action
	clickOption(action: string) {
		const { onOptionClick } = this.args;

		if (onOptionClick) {
			onOptionClick(action);
		}
	}

	<template>
		{{#if this.isOptionsButtonShown}}
			<OptionsButton
				@options={{this.options}}
				@onAction={{this.clickOption}}
				@theme="blue"
				@showMainActionIcon={{true}}
				@extraClass="add-button"
			/>
		{{else}}
			<SubmitButton @text={{@text}} @icon={{this.icon}} @onTrigger={{@callTrigger}} />
		{{/if}}
		<ActionNew @onTrigger={{@callTrigger}} />
	</template>
}
